// src/components/Studio/StudioSection.tsx
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CONTAINER, EYEBROW, GHOST_BUTTON } from './studioStyles';

interface StudioSectionProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  children: ReactNode;
  /** Renders without the horizontal container, for full-bleed content. */
  bleed?: boolean;
}

const StudioSection = ({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = 'See all',
  children,
  bleed = false,
}: StudioSectionProps) => (
  <section className="py-16 sm:py-20">
    <div className={bleed ? '' : CONTAINER}>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="max-w-2xl">
          {eyebrow && <p className={EYEBROW}>{eyebrow}</p>}
          <h2 className="heading-cinematic mt-3 text-2xl text-white sm:text-3xl">{title}</h2>
          {description && (
            <p className="mt-3 text-sm leading-relaxed text-neutral-400 sm:text-base">
              {description}
            </p>
          )}
        </div>

        {linkTo && (
          <Link to={linkTo} className={GHOST_BUTTON}>
            {linkLabel}
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        )}
      </div>

      <div className="mt-10">{children}</div>
    </div>
  </section>
);

export default StudioSection;
